import styled from 'styled-components';
import { spacing, colors, body1 } from 'ui/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${spacing.base};
  gap: ${spacing.base};
  width: 100%;
  background: ${colors.backgroundSecondary};
  margin-bottom: ${spacing.base};
  border-radius: ${spacing.half};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: ${spacing.quarter};
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.base};
  flex: 1 0 0;
  height: ${spacing.doubleHalf};
  overflow: hidden;

  &[data-is-editing-title='true'] {
    overflow: visible;
  }
`;

export const TitleField = styled.div`
  display: flex;
  align-items: center;
  flex: 1 0 0;
  overflow: hidden;

  &[data-is-editing-title='true'] {
    overflow: visible;
  }
`;

export const ButtonNameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing.half};
  overflow: hidden;
`;

export const ReadOnly = styled.div`
  ${body1}
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
`;

export const ActionsInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: ${spacing.base};
  border-top: ${spacing.single} solid ${colors.borderPrimary};
`;

export const RadioOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
`;
